import React from 'react';
import { Modal, Button } from '../ui';

const UnsavedFieldChangesModal = ({ show, onSaveAndContinue, onDiscardChanges, onCancel }) => (
  <Modal
    show={show}
    onClose={onCancel}
    title="Unsaved Changes"
    footer={
      <>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" onClick={onDiscardChanges}>Discard Changes</Button>
        <Button variant="primary" onClick={onSaveAndContinue}>Save & Continue</Button>
      </>
    }
  >
    <p className="builder-text-secondary">
      You have unsaved changes to this question. Would you like to save them before continuing?
    </p>
  </Modal>
);

export default UnsavedFieldChangesModal;
